
<div class="row">
    <!-- BEGIN col-9 -->
    <div class="col-xl-9">
        <!-- BEGIN #general -->
        <div id="styling" class="mb-5" *ngIf="settings">
            <h4 class="h4"><i class="fa fa-pencil fa-fw text-theme"></i> Styling</h4>
            <p>View and update your general account information and settings.</p>
            <div class="card">
                <div class="list-group list-group-flush">
                    <div class="list-group-item d-flex align-items-center">
                        <div class="flex-1 text-break">
                            <div>Orgnaisation Name</div>
                            <div class="text text-opacity-50">{{customer?.customerName}}</div>
                            
                        </div>
                        <!--<div class="w-100px">
                            <a href="#modalEdit" data-bs-toggle="modal" class="btn btn-outline-default w-100px">Edit</a>
                        </div>-->
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                        <div class="flex-1 text-break fixed">
                            <div>Logo (150 x 150)</div>
                            <div class="text text-opacity-50" *ngIf="!edit">{{settings.logoUrl}}</div>
                            <input class="form-control" placeholder="First" [(ngModel)]="settings.logoUrl" *ngIf="edit">
                        </div>
                        <!--<div>
                            <a href="#modalEdit" data-bs-toggle="modal" class="btn btn-outline-default w-100px">Edit</a>
                        </div>-->
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                        <div class="flex-1 text-break fixed">
                            <div>Theme Colour</div>
                            <div class="text text-opacity-50" *ngIf="!edit">
                                <div class="theme-list">
                                    <div class="theme-box"><a (click)="changeThemeColour('pink')"      class="theme-box-link btn btn-{{settings.themeColour}}"></a></div>
                                </div>
                            </div>
                            <div class="theme-list" *ngIf="edit">
                                <div class="theme-box"><a (click)="changeThemeColour('pink')"      class="theme-box-link btn btn-pink"       data-theme-class="theme-pink"     data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Pink"><i *ngIf="app.themeColour == 'pink'" class="fa fa-check"></i></a></div>
                                <div class="theme-box"><a (click)="changeThemeColour('red')"       class="theme-box-link btn btn-red"        data-theme-class="theme-red"      data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Red"><i *ngIf="app.themeColour == 'red'" class="fa fa-check"></i></a></div>
                                <div class="theme-box"><a (click)="changeThemeColour('warning')"   class="theme-box-link btn btn-warning"    data-theme-class="theme-warning"  data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Orange"><i *ngIf="app.themeColour == 'warning'" class="fa fa-check"></i></a></div>
                                <div class="theme-box"><a (click)="changeThemeColour('yellow')"    class="theme-box-link btn btn-yellow"     data-theme-class="theme-yellow"   data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Yellow"><i *ngIf="app.themeColour == 'yellow'" class="fa fa-check"></i></a></div>
                                <div class="theme-box"><a (click)="changeThemeColour('lime')"      class="theme-box-link btn btn-lime"       data-theme-class="theme-lime"     data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Lime"><i *ngIf="app.themeColour == 'lime'" class="fa fa-check"></i></a></div>
                                <div class="theme-box"><a (click)="changeThemeColour('green')"     class="theme-box-link btn btn-green"      data-theme-class="theme-green"    data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Green"><i *ngIf="app.themeColour == 'green'" class="fa fa-check"></i></a></div>
                                <div class="theme-box"><a (click)="changeThemeColour('teal')"      class="theme-box-link btn btn-teal"       data-theme-class="theme-teal"     data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Teal"><i *ngIf="app.themeColour == 'teal'" class="fa fa-check"></i></a></div>
                                <div class="theme-box"><a (click)="changeThemeColour('info')"      class="theme-box-link btn btn-info"       data-theme-class="theme-info"     data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Cyan"><i *ngIf="app.themeColour == 'info'" class="fa fa-check"></i></a></div>
                                <div class="theme-box"><a (click)="changeThemeColour('primary')"   class="theme-box-link btn btn-primary"    data-theme-class="theme-primary"  data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Blue"><i *ngIf="app.themeColour == 'primary'" class="fa fa-check"></i></a></div>
                                <div class="theme-box"><a (click)="changeThemeColour('purple')"    class="theme-box-link btn btn-purple"     data-theme-class="theme-purple"   data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Purple"><i *ngIf="app.themeColour == 'purple'" class="fa fa-check"></i></a></div>
                                <div class="theme-box"><a (click)="changeThemeColour('indigo')"    class="theme-box-link btn btn-indigo"     data-theme-class="theme-indigo"   data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Indigo"><i *ngIf="app.themeColour == 'indigo'" class="fa fa-check"></i></a></div>
                                <div class="theme-box"><a (click)="changeThemeColour('gray-200')"  class="theme-box-link btn btn-gray-100"   data-theme-class="theme-gray-200" data-toggle="theme-selector" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-container="body" data-bs-title="Gray"><i *ngIf="app.themeColour == 'gray-200'" class="fa fa-check"></i></a></div>
                                
                            </div>
                        </div>
                        <!--<div>
                            <a href="#modalEdit" data-bs-toggle="modal" class="btn btn-outline-default w-100px">Edit</a>
                        </div>-->
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                        <div class="flex-1 text-break fixed">
                            <div>Platform Title</div>
                            <div class="text text-opacity-50" *ngIf="!edit">{{settings.applicationName}}</div>                            
                            <input class="form-control" placeholder="First" [(ngModel)]="settings.applicationName" *ngIf="edit">
                        </div>
                        <!--<div>
                            <a href="#modalEdit" data-bs-toggle="modal" class="btn btn-outline-default w-100px">Edit</a>
                        </div>-->
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                        <div class="flex-1 text-break fixed">
                            <div>Home Screen Message</div>
                            <div class="text text-opacity-50" *ngIf="!edit">{{settings.homeScreenMessage}}</div>                            
                            <input class="form-control" placeholder="Blank for Default" [(ngModel)]="settings.homeScreenMessage" *ngIf="edit">
                        </div>
                        <!--<div>
                            <a href="#modalEdit" data-bs-toggle="modal" class="btn btn-outline-default w-100px">Edit</a>
                        </div>-->
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                        <div class="flex-1 text-break fixed">
                            <div>Background Image (1920 x 1280)</div>
                            <div class="text text-opacity-50" *ngIf="!edit">{{settings.backgroundImageUrl}}</div>
                            <input class="form-control" placeholder="First" [(ngModel)]="settings.backgroundImageUrl" *ngIf="edit">

                        </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                        <div>
                            <a (click)="enableEdit()" *ngIf="!edit" data-bs-toggle="modal" class="btn btn-outline-default w-100px">Edit</a>
                            <a (click)="saveChanges()" *ngIf="edit" data-bs-toggle="modal" class="btn btn-outline-default w-100px">Save</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- END #general -->
      
        
        <!-- BEGIN #system -->
        <div id="system" class="mb-5">
            <h4 class="h4"><i class="fa fa-floppy-o fa-fw text-theme"></i> System</h4>
            <p>System storage, bandwidth and database setting</p>
            <div class="card">
                <div class="list-group list-group-flush">
                    <div class="list-group-item d-flex align-items-center">
                        <div class="flex-1 text-break">
                            <div>Web storage</div>
                            <div class="text text-opacity-50">
                                TBC
                            </div>
                        </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                        <div class="flex-1 text-break">
                            <div>Monthly bandwidth</div>
                            <div class="text text-opacity-50">
                                Unlimited
                            </div>
                        </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                        <div class="flex-1 text-break">
                            <div>Database</div>
                            <div class="text text-opacity-50">
                                {{databaseTechnology}}
                            </div>
                        </div>
                        <div *ngIf="connectionString == null">
                            <a (click)="generateConnectionString()" class="btn btn-outline-theme event-control">Generate Connection String (1 Year)</a>
                        </div>
                        <div *ngIf="connectionString != null">
                            <input type="text" disabled="true" [(ngModel)]="connectionString" class="form-control event-control"/>
                        </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                        <div class="flex-1 text-break">
                            <div>Platform</div>
                            <div class="text text-opacity-50">
                                INDICIUM Stack
                            </div>
                        </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                        <div class="flex-1 text-break">
                            <div>Support</div>
                            <div class="text text-opacity-50">
                                {{supportLevel}}
                            </div>
                        </div>
                        <!--<div>
                            <a href="#modalEdit" data-bs-toggle="modal" class="btn btn-outline-theme w-100px" disabled="true">Update</a>
                        </div>-->
                    </div>
                </div>
            </div>
        </div>
        <!-- END #system -->
    </div>
    <!-- END col-9-->
    <!-- BEGIN col-3 -->
    <div class="col-xl-3">
        <!-- BEGIN #sidebar-bootstrap -->
        <nav id="sidebar-bootstrap" class="navbar navbar-sticky d-none d-xl-block">
            <nav class="nav">
                <a class="nav-link" routerLink="." fragment="style" data-toggle="scroll-to">Style</a>
                <a class="nav-link" routerLink="." fragment="system" data-toggle="scroll-to">System</a>
            </nav>
        </nav>
        <!-- END #sidebar-bootstrap -->
    </div>
    <!-- END col-3 -->
</div>
